<template>
  <div class="flex flex-col h-full">
    <div class="flex-auto overflow-scroll">
      <div class="pt-4 px-4 mb-4 flex content-center">
        <div
          @click="utils.goBack(router, '/admin/recibos')"
          class="pr-2 flex items-center cursor-pointer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-6 h-6"
          >
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
          </svg>
        </div>
        <h3 class="text-2xl font-bold">Corte</h3>
      </div>

      <div class="flex flex-row w-full px-4 gap-4">
        <select v-model="month" class="border border-gray-300 rounded w-full py-2 px-3">
          <option v-for="option in months" :key="option.value" :value="option.value">
            {{ option.label }}
          </option>
        </select>
        <select v-model="year" class="border border-gray-300 rounded w-full py-2 px-3">
          <option v-for="option in years" :key="option" :value="String(option)">
            {{ option }}
          </option>
        </select>
      </div>

      <div class="w-full text-left px-4 py-2">
        <select v-model="proveedor" class="border border-gray-300 rounded w-full py-2 px-3">
          <option :value="null" disabled>Escoge un proveedor</option>
          <option v-for="option in proveedores" :key="option.id" :value="option">
            {{ option.nombre }}
          </option>
        </select>
      </div>

      <div
        v-if="requestedCollections.length > 0"
        class="mx-4 mt-2 rounded border border-yellow-500 bg-yellow-50 p-4"
      >
        <p class="font-bold">No se puede hacer el corte.</p>
        <p>Resuelve las recolecciones solicitadas:</p>
        <div class="flex gap-2 mt-2">
          <router-link
            v-for="collection in requestedCollections"
            :key="collection.id"
            :to="`/admin/recolecciones/${collection.id}`"
            class="underline font-medium"
          >
            #{{ collection.id }}
          </router-link>
        </div>
      </div>

      <div v-if="preview" class="border border-gray-300 rounded bg-white m-4 overflow-scroll">
        <table class="w-full text-sm text-left">
          <thead class="border-b">
            <tr>
              <th class="py-3 px-6">Periodo</th>
              <th class="py-3 px-6">Almacén</th>
              <th class="py-3 px-6">Entregas</th>
              <th class="py-3 px-6">Recolecciones</th>
              <th class="py-3 px-6">Extras</th>
              <th class="py-3 px-6">Total (c/IVA)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="py-3 px-6">{{ month }}/{{ year }}</td>
              <td class="py-3 px-6">{{ formatMoney(preview.totales.almacen) }}</td>
              <td class="py-3 px-6">{{ formatMoney(preview.totales.entregas) }}</td>
              <td class="py-3 px-6">{{ formatMoney(preview.totales.recolecciones) }}</td>
              <td class="py-3 px-6">{{ formatMoney(preview.totales.extras) }}</td>
              <td class="py-3 px-6">{{ formatMoney(preview.totales.total_con_iva) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h3 class="block text-gray-700 text-sm font-bold px-4 mt-4">Recolecciones</h3>
      <empty v-if="preview && recolecciones.length === 0" :texto="'No hubo recolecciones'" />
      <div v-if="recolecciones.length > 0" class="w-full text-left p-4">
        <div class="border border-gray-300 rounded bg-white overflow-scroll">
          <table class="w-full text-sm text-left">
            <thead class="border-b">
              <tr>
                <th class="py-3 px-6">Recolección</th>
                <th class="py-3 px-6">Fecha solicitada</th>
                <th class="py-3 px-6">Distancia</th>
                <th class="py-3 px-6">Distancia facturable</th>
                <th class="py-3 px-6">Órdenes</th>
                <th class="py-3 px-6">Costo</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="collection in recolecciones" :key="collection.id" class="border-b">
                <td class="py-3 px-6 underline">
                  <router-link :to="`/admin/recolecciones/${collection.id}`">#{{ collection.id }}</router-link>
                </td>
                <td class="py-3 px-6">{{ formatDate(collection.solicitada_at) }}</td>
                <td class="py-3 px-6">{{ formatDistance(collection.distancia) }}</td>
                <td class="py-3 px-6">{{ formatDistance(collection.distancia_facturable) }}</td>
                <td class="py-3 px-6">{{ collection.pedidos }}</td>
                <td class="py-3 px-6">{{ formatMoney(collection.costo) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <h3 class="block text-gray-700 text-sm font-bold px-4 mt-4">Envíos</h3>
      <empty v-if="preview && envios.length === 0" :texto="'No hubo entregas'" />
      <div v-if="envios.length > 0" class="w-full text-left p-4">
        <div class="border border-gray-300 rounded bg-white overflow-scroll">
          <table class="w-full text-sm text-left">
            <thead class="border-b">
              <tr>
                <th class="py-3 px-6">Pedido</th>
                <th class="py-3 px-6">Status</th>
                <th class="py-3 px-6">Fecha</th>
                <th class="py-3 px-6">Distancia</th>
                <th class="py-3 px-6">Costo</th>
                <th class="py-3 px-6">Extra</th>
                <th class="py-3 px-6"></th>
              </tr>
            </thead>
            <tbody>
              <template v-for="delivery in envios" :key="delivery.id">
                <tr class="border-b">
                  <td class="py-3 px-6 underline">
                    <router-link :to="`/proveedor/${proveedor.id}/orden/${delivery.pedido_id}`">
                      {{ delivery.pedido_id }}
                    </router-link>
                  </td>
                  <td class="py-3 px-6">{{ delivery.status }}</td>
                  <td class="py-3 px-6">{{ formatDate(delivery.created_at) }}</td>
                  <td class="py-3 px-6">{{ formatDistance(delivery.distancia) }}</td>
                  <td class="py-3 px-6">{{ formatMoney(delivery.costo) }}</td>
                  <td class="py-3 px-6">{{ formatMoney(delivery.cargo_extra) }}</td>
                  <td class="py-3 px-6">
                    <button class="underline" @click="toggleDelivery(delivery.id)">Editar</button>
                  </td>
                </tr>
                <tr v-if="showEnvio[delivery.id]" class="border-b">
                  <td colspan="7" class="py-2 px-4">
                    <div class="flex gap-4">
                      <input v-model="delivery.new_costo" type="number" min="0" placeholder="Costo" class="w-full border rounded py-2 px-3" />
                      <input v-model="delivery.new_extra" type="number" min="0" placeholder="Cargo extra" class="w-full border rounded py-2 px-3" />
                    </div>
                    <button class="w-full bg-primary text-white font-bold py-2 px-4 mt-2 rounded" @click="updateEnvio(delivery)">
                      Actualizar
                    </button>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div v-if="proveedor && preview" class="p-4 flex-none border-t border-gray-300">
      <button
        class="w-full bg-primary hover:bg-primary-dark rounded text-white font-bold py-2 px-4 disabled:opacity-50"
        :disabled="requestedCollections.length > 0 || preview.recibo_existente"
        @click="hacerCorte"
      >
        Hacer corte
      </button>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useLoading } from "vue-loading-overlay";
import { useToast } from "vue-toast-notification";
import { utils } from "./utils/utils.js";

const monthNames = [
  "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
];

export default {
  setup() {
    const route = useRoute();
    const router = useRouter();
    const now = new Date();
    const proveedor = ref(null);
    const proveedores = ref([]);
    const month = ref(String(now.getMonth() + 1));
    const year = ref(String(now.getFullYear()));
    const preview = ref(null);
    const showEnvio = ref([]);
    const loader = useLoading({ color: "#428b74", loader: "spinner" });
    const months = monthNames.map((label, index) => ({
      label,
      value: String(index + 1),
    }));
    const years = Array.from(
      { length: 8 },
      (_, index) => now.getFullYear() - 4 + index
    );
    const envios = computed(() => preview.value?.envios || []);
    const recolecciones = computed(() => preview.value?.recolecciones || []);
    const requestedCollections = computed(
      () => preview.value?.recolecciones_solicitadas || []
    );

    async function loadPreview() {
      preview.value = null;
      if (!proveedor.value?.id || !month.value || !year.value) return;
      try {
        preview.value = await utils.getCortePreview(
          proveedor.value.id,
          Number(month.value),
          Number(year.value)
        );
      } catch (error) {
        useToast().error(error.message, { position: "top-right" });
      }
    }

    async function hacerCorte() {
      if (requestedCollections.value.length > 0) return;
      if (!confirm("¿Quieres hacer este corte?")) return;
      const activeLoader = loader.show();
      try {
        const result = await utils.crearCorte(
          proveedor.value.id,
          Number(month.value),
          Number(year.value)
        );
        await router.push(`/admin/recibo/${result.recibo.id}`);
      } catch (error) {
        useToast().error(error.message, { position: "top-right" });
        await loadPreview();
      } finally {
        activeLoader.hide();
      }
    }

    async function updateEnvio(delivery) {
      const data = {};
      if (delivery.new_costo !== undefined && delivery.new_costo !== "") {
        data.costo = delivery.new_costo;
      }
      if (delivery.new_extra !== undefined && delivery.new_extra !== "") {
        data.cargo_extra = delivery.new_extra;
      }
      if (Object.keys(data).length === 0) return;
      try {
        await utils.updateEnvio(delivery.id, data);
        showEnvio.value[delivery.id] = false;
        await loadPreview();
        useToast().success("Envío actualizado", { position: "top-right" });
      } catch (error) {
        useToast().error(error.message, { position: "top-right" });
      }
    }

    function toggleDelivery(id) {
      showEnvio.value[id] = !showEnvio.value[id];
    }
    function formatMoney(value) {
      return new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
      }).format(Number(value || 0));
    }
    function formatDate(value) {
      return value
        ? new Date(value).toLocaleDateString("en-GB", {
            timeZone: "America/Mexico_City",
          })
        : "";
    }
    function formatDistance(value) {
      return value == null
        ? "—"
        : `${Math.round((Number(value) / 1000) * 100) / 100} km`;
    }

    onMounted(async () => {
      proveedores.value = await utils.getProveedores();
    });
    watch([() => proveedor.value?.id, month, year], loadPreview);

    return {
      route,
      router,
      utils,
      proveedor,
      proveedores,
      month,
      year,
      months,
      years,
      preview,
      envios,
      recolecciones,
      requestedCollections,
      showEnvio,
      hacerCorte,
      updateEnvio,
      toggleDelivery,
      formatMoney,
      formatDate,
      formatDistance,
    };
  },
};
</script>
